import React from 'react';

var ViewAllTrigger = function ViewAllTrigger(_ref) {
  var viewAll = _ref.viewAll,
      toggle = _ref.toggle;
  return React.createElement("div", {
    className: "view-all-trigger bg-snowbound py-1 mt-4 mb-5"
  }, React.createElement("div", {
    style: {
      cursor: 'pointer'
    },
    className: "text-center view-all",
    onClick: function onClick(e) {
      toggle();
    }
  }, React.createElement("span", {
    className: 'text-brond  underline uppercase leading-2 font-bold'
  }, viewAll ? 'View more' : 'View less')));
};

export default ViewAllTrigger;